import { render, staticRenderFns } from "./GIS2DViewer.vue?vue&type=template&id=299bb076&scoped=true&"
import script from "./GIS2DViewer.vue?vue&type=script&lang=js&"
export * from "./GIS2DViewer.vue?vue&type=script&lang=js&"
import style0 from "./GIS2DViewer.vue?vue&type=style&index=0&id=299bb076&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299bb076",
  null
  
)

export default component.exports